import { render, staticRenderFns } from "./SearchBlock.vue?vue&type=template&id=2beeea36"
import script from "./SearchBlock.vue?vue&type=script&lang=js"
export * from "./SearchBlock.vue?vue&type=script&lang=js"
import style0 from "./SearchBlock.vue?vue&type=style&index=0&id=2beeea36&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports